import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { FadeUp } from '../ui/FadeUp';
export function CreatorSection() {
  const credentials = ['Coach Ontológico Profesional (ICF)', 'Formación en Sanación Energética', 'Escuela Barbara Ann Brennan', 'Maestría en Registros Akáshicos'];
  return <SectionWrapper bgColor="white" id="about" data-id="element-20">
      <div className="flex flex-col gap-0" data-id="element-21">
        <FadeUp data-id="element-22">
          <p className="text-[10px] tracking-[0.2em] uppercase text-plum font-medium mb-3" data-id="element-23">
            Quién creó este sistema
          </p>
          <h2 className="text-[clamp(28px,8vw,38px)] mb-5" data-id="element-24">
            Formación que
            <br data-id="element-25" />
            <em className="font-serif italic text-plum" data-id="element-26">respalda cada fase</em>
          </h2>

          <div className="w-full max-w-[320px] mx-auto my-7" data-id="element-27">
            <video src="https://cdn.magicpatterns.com/uploads/iQHTN33so69PkoJZQvrHcz/0226.mp4" controls preload="none" poster="https://cdn.magicpatterns.com/uploads/f8KD6ieSVrkSCABejZc8Dz/image.png" className="w-full h-auto rounded-[8px] shadow-lg" style={{
            aspectRatio: '9 / 16'
          }} data-id="element-28">
              Tu navegador no soporta el elemento de video.
            </video>
          </div>

          <div className="flex flex-col gap-2 mb-6" data-id="element-29">
            {credentials.map((cred, index) => <div key={index} className="flex items-center gap-2.5 text-[13px] text-charcoal" data-id="element-30">
                <div className="w-1.5 h-1.5 bg-plum rounded-full flex-shrink-0" data-id="element-31" />
                <span data-id="element-32">{cred}</span>
              </div>)}
          </div>

          <div className="space-y-3.5" data-id="element-33">
            <p className="text-[14px] text-muted leading-[1.75]" data-id="element-34">
              Después de mucho tiempo de trabajar con personas de alto
              rendimiento, noté un patrón: el éxito profesional no garantizaba
              la paz interna.
            </p>
            <p className="text-[14px] text-muted leading-[1.75]" data-id="element-35">
              Creé ProMind Energy no como una práctica espiritual más, sino como{' '}
              <em className="font-serif italic text-[16px] text-charcoal" data-id="element-36">
                un sistema de higiene energética necesario para sostener la
                responsabilidad sin agotarse.
              </em>
            </p>
            <p className="text-[14px] text-muted leading-[1.75]" data-id="element-37">
              ProMind Energy no nació de la teoría. Nació de observar un patrón
              repetido en mujeres altamente responsables.
            </p>
          </div>
        </FadeUp>
      </div>
    </SectionWrapper>;
}